import { iconButton } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'iconButton',
  label: 'Icon Button',
  category: 'Data Display',
  image: iconButton
};
